
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's03c44f5a1b0581d4': `ausgewählt`,
's03c75db6e18f29d2': `anmelden`,
's03f42eea72154959': `Nutzername`,
's053eb89714fe5c46': `Leistung`,
's05e136e67bf479ad': `Meter`,
's0654bb31ab7b7181': `Gewählte Eigenschaften`,
's080f5119176d1ff9': `max`,
's08bddfaaf372f2f2': `Projekt Adresse`,
's091d5d07b5b33dcf': `OK`,
's09b7ae18afb52426': `Lichtprofil`,
's0a95ea7c8e330485': `Breite`,
's0b43e6e909895c89': `Horizontal`,
's0bd108911963a54f': `kalt`,
's0bdb10ecdb3fce26': `Datenblatt Personalisierung`,
's0d1be7a2c400c080': `weitere`,
's0d249b4af3381730': `Bitte einloggen`,
's0ddc950e757e1973': `Basis Datenblatt`,
's0ed0176ae4af6fd2': `Jahresübersicht`,
's0eeef467da6b181a': `Der Ort ist ausschlaggebend für die Konfiguration. Jeder Ort hat andere Begebenheiten.`,
's0fb158a2339568d6': `Personalisierung`,
's0fbf6dc6a1966408': `Weiter`,
's101f0e6c075f0306': `Persönliche Beratung`,
's11354e32ca275229': `Lichtpunkt`,
's125083191daf6f61': `gering`,
's15a852e9f9a50fa5': `Juni`,
's15b92ca12f290f37': `24h Dimmprofil`,
's1667f96d19635ec7': `Zone`,
's16b9446e3a70e1f4': `Merkmale`,
's16beb7f7aca65d4a': `Ihre Lichtkonfiguration ist bereit zum Download.`,
's180f872a88570719': `Zubehör`,
's18f78df8a253a3bd': `Diese Konfiguration ändern`,
's19e8d4c5ba537449': `Produkt ID`,
's1c9fc46adbc800fc': `We konnten den eingegeben Ort nicht finden.`,
's1da50951bdd7a204': `Kanal`,
's1e49e107896ce7fe': `Der erste Schritt ist getan.`,
's1eb320f7fc4c79d3': `Olivio`,
's2122b8c621efd5fe': `Ausschreibungstext`,
's2138d5192571b731': `neu`,
's21900f027f2d7cfa': `Durchmesser`,
's21f4cc510ca89b33': `Weiter konfigurieren`,
's22a8350054d8a2f3': `angeschlossene Zuleitung`,
's23685a920290045d': `Lichtpunkt`,
's25858219b90108cb': `LDT`,
's25f6e9b435aa1079': `Kabelsicherungskasten`,
's2652c22671dc46da': `Diese Konfiguration kopieren`,
's26d236d09a66a620': `Regeln`,
's26f5f8b809fd7fe5': `Produktbild herunterladen (png)`,
's2759a0a1d167ad8d': `Bitte einloggen`,
's27c10d6b0a1f1eb1': `auf Anfrage`,
's281e280dac2b6d0f': `Basisdaten`,
's28414724644bccc4': `Beispieltage`,
's28e1da9966f65d52': `Mögliche Lichtpunkthöhen`,
's2937ff34f32d2b26': `Preisliste`,
's295b16cb2e4eeaa7': `Erfahre mehr über`,
's2c6d92528b3eec9b': `Entwurfsdatenblatt, Produkt- und Projektbilder`,
's2cb4ef8646d0e517': `Montageanleitung`,
's2ceb11be2290bb1b': `Abbrechen`,
's2deee7c162e1558b': `abmelden`,
's2ee707397f19f23d': `Ganzjahresprofil (max)`,
's2fba71bd651bdbfb': `Vertikal`,
's302c01e9021c7d0a': `Referenztage: Winter 21.Dez., Sommer 21.Jul., Frühjahr/Herbst: 21.Sep.`,
's30c5118924e9ccf7': `Montageanleitung`,
's324d6c1ce4504744': `Autarkietage`,
's32608f5f2b7f01ff': `Offene Eigenschaften`,
's351c13d86108cce3': `Kopf`,
's36a54400db774fd6': `Ort außerhalb des Konfigurationsbereichs`,
's37643c19c348229c': `Nr.`,
's3800b4d177951a38': `Winkel bzgl. Masttür`,
's387622cbff9d7bdc': `Früh./Herbst`,
's38cb83ea5c1270b3': `Lichtverteilung`,
's3b0ab4b52326316f': `Licht`,
's3c04f27ce20ea918': `Gesamthöhe`,
's3d4a07895c83def3': `Diese Einstellungen werden auf alle Köpfe angewendet`,
's3fda2cc80886276c': `Meter`,
's4006039e1a7433a1': `Lade Specifikations-ID`,
's4394ed0a03867f18': `Lichtpunkthöhe`,
's44632e3cdf4265d0': `Lampenlichtstromwartungsfaktor`,
's464ff0695f87139f': `Für diesen Standort nehmen Sie bitte Kontakt mit uns auf, damit wir Ihnen ein persönliches
					Circulares Lichtprofil erstellen können.
				`,
's478248ace1f398b0': `Köpfe`,
's47ebf3a8fb3b10c1': `Ausrichtung`,
's48344928cb4a4f8d': `Wählen Sie einen Ort`,
's48e186fb300e5464': `Zeit`,
's48f220d2f0f98106': `Datenblatt ansehen`,
's4f4a0a3957f6409b': `Spezifikations ID`,
's4f8c1254653e1188': `gedimmte Leistung`,
's5048efbcb03a6a20': `Lichtechnische Daten`,
's5052d10b539eabf0': `März`,
's5139cc56230d0317': `Ausschreibungstexte`,
's52d1befc2b7b05b6': `Konfigurations-ID`,
's5390f55090d59178': `Aeto passt sich flexibel an die Umgebungs- und Projektanforderungen an. Ermitteln Sie mit
					unserem Konfigurator anhand statistischer Sonnen- und Wetterdaten der mindestens letzten 10 Jahre
					mögliche Lichtleistungen in Abhängigkeit der Größe der Solareinheit.
				`,
's53c69c5f21db188f': `Unterer Lichtpunkt`,
's542a2430b5e7bf68': `Die Sonneneinstrahlung wird ohne Verschattung und mit Ausrichtung nach Norden berechnet.
				`,
's5548520a6d89e647': `Weitere verfügbare Eigenschaften`,
's56a0dcacefc0078c': `LDT Dateien`,
's56f9bc194465a83c': `oben`,
's59b52ef0a2362cf4': `Lichtprofil`,
's5bb297d85a6de998': `Winkel`,
's5c61760bb5831e7a': `Datenblatt prüfen und Konfiguration abschließen`,
's5ca9a41556de2c52': `Masttüren`,
's5dd028a12ddb124b': `Ihr Lichtprofil`,
's5e399df62bea2918': `warm`,
's5fcdde07ae1161a8': `Alle Jahresseiten`,
's600662143fc19adc': `Frühling/Herbst`,
's61053f0e3ebbd272': `normal`,
's617ddd6d427c8cb3': `Detaildatenblatt, Produkt- und Projektbilder`,
's6387848b18b50c80': `Detail Datenblatt`,
's63cc891eb48fbf58': `Ihre Leuchte`,
's63d1951640439972': `Produkte und Bestandteile`,
's63e457bc703a3030': `E-Mail`,
's6686fcc6d2c8f0bd': `Notiz`,
's669b18c6d2d9c95b': `Ohne`,
's66c5b77248cfa1af': `Leuchtendaten`,
's67e5c254c4d8832d': `Email-Anfrage für mehr Informationen`,
's682df6874fed3750': `Tabellenansicht`,
's6909fbf252fb79dc': `Bitte zur Anmeldung Zugangsdaten eingeben.`,
's6a11b5bd13c5c0bf': `Anwendungen mit erweiterten Features`,
's6a5a1ac0f1a00bc5': `bestehend aus`,
's6b61044deda3df65': `Das gewünschte Feature nicht möglich mit zuvor getroffenen Entscheidungen. Wollen Sie diese
					Felder deaktivieren um fortzufahren?
				`,
's6b7d7afabc24ff1c': `Merkmale`,
's6e254074fbee8e0d': `gedimmter`,
's6ec56fb545de4b76': `Nehmen Sie gern für einen persönlichen Austausch und weitere Informationen Kontakt mit uns
					auf.
				`,
's6fd32ab00cd5b6fd': `Oberer Lichtpunkt`,
's7360eecc9b38343d': `hoch`,
's740de1b7b1a14f0c': `Lichtausbeute`,
's7574e7a84b0fb574': `Sommer`,
's75ed09a809d91f7b': `Grundpreis`,
's76bab8c674e485c3': `Spezifikationen`,
's7878f63fba88920a': `Referenztage: Sommer 21.Dez., Winter 21.Jul., Frühjahr/Herbst: 21.Sep.`,
's79031140b7a4524b': `Photometrien, Revit, Montageanleitung`,
's794a2ed0326f8bd3': `Lichtverteilung`,
's7965f9dc5548469e': `Ihre Zone:`,
's79a9ea7671b44bdc': `Konfigurieren Sie für Ihr Projekt die neue effiziente Aeto Solarleuchte.`,
's79aea3f15705d95d': `Naturzentrierte Beleuchtung`,
's79c731c42cef04ba': `Modellübersicht, Produkt- und Projektbilder`,
's7cb4e55c59663b1c': `Unternehmen`,
's7e87a6b2c1d7bc13': `Ausleger`,
's7ebe6e1acc5d757a': `Schmal`,
's8031a80d73f6ebe0': `Nummer`,
's80629ca60d4d77eb': `Lichtprofil im Detail erleben`,
's8270995cf37770f1': `Ausschreibungstext kopieren`,
's8310bd373d383154': `Neue Konfiguration starten`,
's84e4ad9f3933d98d': `Für erweiterte Konfigurationsoptionen, bitte`,
's85b8f40120ac19bf': `Abschließen`,
's863b04cd4fb72226': `Batteriekapazität`,
's8677332490c997b4': `Projektbilder`,
's874b4e33320ea9fa': `LDT Seite`,
's8750ed2a956654c9': `Datenblatt`,
's87bae2710b2492c3': `Kontakt`,
's87d32bdbee7f327f': `Ihr Lichtprofil:`,
's89e9be1960f4c21c': `rot`,
's8a06a737a64acb51': `Konfiguration abschließen`,
's8a957ce1c55ba8f0': `Angemeldet:`,
's8b15707964e87086': `Lichtprofil`,
's8c0df50fb122616e': `Brennweite`,
's8d0c149470d44f94': `Sommer`,
's8d5cb019f3cae535': `PDF`,
's8d802fff3bde98c3': `Neue Konfiguration starten`,
's904478720bf69a20': `Ausschreibungstext in Zwischenablage kopieren`,
's923a14357bb70193': `Herbst`,
's93b105b3cd3a4cba': `Artikelnummer`,
's94d7caa74edbbffc': `Konfigurieren Sie hier die Aluminium-Version.`,
's97de9a19fa44513a': `Serienr.`,
's9822e5e8ef283182': `Lichtintensität`,
's9844ab19fa9b214f': `Sep`,
's9a6e47771188568d': `Verschattung`,
's9ae3ff84f2b87d2b': `PDF herunterladen`,
's9bf7d6fdcd9de5ce': `Aus dieser Erkenntnis entstand die Idee, künstliches Licht natürlichen Rhythmen anzupassen:
					jeden Tag, zu jeder Jahreszeit und an jedem Ort der Welt ein wenig anders – aber immer einzigartig.
				`,
's9cd05d781f493167': `Projektname/ID`,
's9d8b8aa2b404c2c8': `Einstellungen`,
's9e68097114e9bc2e': `Detailierte Konfiguration von Lichtprofilen`,
's9eba0933010df96e': `Mehr informationen`,
's9ec2699513c0f9c3': `schließen`,
's9f0c705e2fd7e391': `Konfiguration starten`,
's9f6131367f5a6a54': `gedimmter Lichtstrom`,
's9f6adc16f5202086': `Produktbilder`,
's9f6bf30ed0f3ca9f': `Bohrmaße`,
'sa0705f8fa177fccd': `inkl.`,
'sa1070ff7d8c004c4': `Uhrzeit`,
'sa12222c2106905a6': `Ein oder mehrere ausgewählte Köpfe wurden bearbeitet. Die Auswahl eines Layouts überschreibt diese individuellen Einstellungen`,
'sa25de1d82d6a4d4e': `Länge`,
'sa36aef46efe431eb': `Modelle`,
'sa3cfca3e99cec11f': `Datenblatt herunterladen`,
'sa56481dc40b0fff2': `Detaildatenblatt`,
'sa875b4fce70c7dcf': `Licht für den Stadtraum. Olivio bietet mit vielfältigen Design- und Beleuchtungsmöglichkeiten
					Gestaltungsfreiheit für einzigartige Rauminszenierungen.
				`,
'sa9f14ae61a187f50': `Lichtfarbe`,
'sab04edd077c7d213': `Die folgenden Eigenschaften sind nicht gesetzt.`,
'sab08f8abe884ba64': `Solareinheit`,
'sab753c5233ef454e': `Produktbeschreibung`,
'sac8252732f2edb19': `Datum`,
'sb33fc919a70e0e33': `Mast`,
'sb543b881adfd8f63': `Neue Konfiguration starten`,
'sb59d68ed12d46377': `Lade`,
'sb6fd9beeccbb8be4': `Bitte Voraussetzungen auswählen um die Dimmung zu ändern.`,
'sb77b5dabc9a1321e': `Ausgewählter Kopf`,
'sb8c3a89a2602d1c6': `Data Hub`,
'sb917400f530da741': `Diese Konfiguration beruht auf einen älteren Datenbestand. Die geladenen Eigenschaften werden soweit möglich korrekt dargestellt, sind jedoch nicht vollständig. Bitte überprüfen Sie diese und konfigurieren Sie bei Bedarf neu.`,
'sba56141a5ab71a2a': `Lichtpunkte`,
'sba98a7152d80b949': `Anzahl`,
'sbb99f4f1499715c1': `Wir freuen uns auf die Zukunft des Lichtes.`,
'sbec5d3de6f675b65': `Lade Modell ID`,
'sc033d576e2617aab': `Die gewünschte Eigenschaft ist nicht möglich mit den vorherigen Entscheidungen.`,
'sc03688bcf16db798': `Produktfamilie wählen`,
'sc0bd6202ba1e9149': `Circulares Lichtprofil`,
'sc141922a5906fd93': `Login anfordern`,
'sc15d10811c62c5eb': `Artikelnummer`,
'sc16e00a7a8b2fde2': `Zurück`,
'sc1966aa0d7e2d0fe': `Unsere Leuchtenempfehlung`,
'sc1a1ae295cc1f0c3': `Berechne Photovoltaikdaten. Bitte warten ...`,
'sc1a4e2a7a8e20d58': `Gründung`,
'sc3878186f443a5e8': `Familienausschreibungstext`,
'sc3f22766aede7f77': `Olivio bietet die ideale Lichtlösung für alle Außenbereiche und garantiert mit drei Designlinien
					– Sistema, Floracion und Candelabra – vielfältige Funktionen.
				`,
'sc42c19e54dee932a': `Konfiguration teilen`,
'sc57d00c739a6b90b': `Detaildatenblatt`,
'sc6c266995fa1f461': `Vertikale Pos.`,
'sc76a095e1ffa22b6': `mittel`,
'sc82317db41b29853': `Modell ID`,
'sc8da3cc71de63832': `Anmelden`,
'sc8f79f1d775ddfa4': `Konfigurator vorübergehend nicht verfügbar`,
'sc9474bf7a0668d73': `Zusammenfassung`,
'sc956f29d2ff0ef07': `Ort nicht gefunden`,
'sca18d17ab22255c3': `Die Konfiguration kann nach dem Abschließen nicht mehr verändert werden.`,
'sca51b3d6b0d00e47': `Verfügbare Leuchten`,
'sca91d01075c0ce84': `Sonnenaufgang`,
'scb320e45978d3390': `Fabrikat`,
'scc75879e9b6998da': `Lumen`,
'scd5bf30253fea7aa': `Weit`,
'sce10e2a2c48d13c0': `Vielen Dank für Ihr Verständnis`,
'sce2d17cf5d18dee3': `Kontakt aufnehmen`,
'sceb0a248069915e2': `Dieser Konfigurator wird derzeit aktualisiert und steht deshalb momentan nicht zur Verfügung. Für Unterstützung wenden Sie sich bitte an Ihren Selux-Ansprechpartner.`,
'scfe3a7e083cd9be6': `Bereite Downloads vor`,
'sd04d174ea40dfa50': `Die Stahl-Variante läuft aus.`,
'sd1e8bf20abe69b4a': `Autarkietage`,
'sd3386a2ef42e80b9': `Download`,
'sd35032a7b73b36ac': `Winter`,
'sd37ea6e6a94f7a7a': `Bohr Parameter`,
'sd5d820e378ce757e': `Montageanleitung`,
'sd697d9c07465ce87': `Sonnenuntergang`,
'sdac1a66caafe39b2': `Konfiguration zurücksetzen`,
'sdad2ea94744ca934': `Familien Datenblatt`,
'sdae662c8473f8db8': `Ausschreibungstext herunterladen`,
'sdb4f497ba38af24e': `von oben`,
'sdcb27818fed9da90': `für`,
'sdce919bbdc89eb6b': `Konfiguriere`,
'sde96c07df45da349': `Familie`,
'se1f4fdbaf847ffb1': `Zuschlag`,
'se25bd8a1ce2fdb60': `Personalisierung ausblenden`,
'se59367ea12bc61cc': `Winter`,
'se5ee9d0c0f004260': `Diese Konfiguration beruht auf einen älteren Datenbestand. Die geladenen Eigenschaften werden soweit möglich korrekt dargestellt, sind jedoch
					nicht vollständig. Bitte überprüfen Sie diese und konfigurieren Sie bei Bedarf neu.
				`,
'se6f09b190519daa4': `alle`,
'se9d2aaa5182ec3fc': `Energieertrag`,
'sec2557a35b702525': `Variable`,
'sec57968fd4931f90': `Konfigurator`,
'seded372023a9fe71': `Lichttechnik`,
'see2fcaedf9743ec6': `Ort`,
'seed76e8afe9f604a': `Preis`,
'sf1bc83d2509bafcf': `Telefon`,
'sf2969ec25d7c997d': `Systemleistung`,
'sf4a1ba82937d9fd3': `Basisdatenblatt`,
'sf5bdced3225ede77': `Besonderheiten`,
'sf6e1665c7022a1f8': `Passwort`,
'sf9b1c0661a02d9f9': `Konfiguration`,
'sfc37108739c69a73': `Basisdatenblatt`,
'sfcb319624c989982': `Ausgewählte Leuchten`,
'sfd1e1dc1bf9acb1b': `Wie muss Licht wirken um Sicherheit, Orientierung und Schönheit zu schaffen? Wie können wir
					verhindern, unsere ökologischen Grenzen noch weiter zu belasten? Gibt es das perfekte Licht?
					Antworten darauf liefert die Natur.
				`,
'sfdc4d81d8340cbd7': `Lichtpunktkonfiguration`,
'sfe6c68330a2bd563': `Licht im natürlichen Rhythmus für Menschen, Pflanzen und Tiere`,
'sffdadf0a576fd802': `Höhe`,
's175d37c8eb04d73e': `Downloads`,
's73d3c06c3590a656': `Eff.`,
'sff2a34f5dc1a1f44': `Inlay`,
    };
  